import { ArrowCircleUpRight } from '@phosphor-icons/react'
import { Popover, PopoverContent, PopoverTrigger } from '@shopflo/ui'
import TelePhone from 'public/images/support/Telephone.png'
import { ExternalLink } from 'react-feather'
import Mail from 'public/images/support/Mail.svg'
import WhatsApp from 'public/images/support/Whatsapp.svg'
import { useLocale } from 'src/lib/hooks/useLocal'
import useGTM from 'src/lib/hooks/useGTM'

const ContactUsPopover = () => {
  const { t } = useLocale()
  const { sendGTMTrigger } = useGTM()
  return (
    <Popover>
      <PopoverTrigger asChild>
        <div
          className='flex items-center gap-4 py-3 px-4 bg-white rounded-xl border-1 border-coal-lighter transition hover:bg-gray-lighter cursor-pointer'
          style={{
            boxShadow: '0px -3px 1.3px 0px #0000001A inset'
          }}
        >
          <div className='flex items-center justify-center'>
            <img src={TelePhone.src} alt='Telephone Icon' width={24} height={24} />
          </div>
          <span className='text-sm font-medium text-carbon'>{'Contact us'}</span>
          <div className='flex items-center justify-center'>
            <ArrowCircleUpRight size={24} color='#1A1A1A' />
          </div>
        </div>
      </PopoverTrigger>

      <PopoverContent
        className='bg-white rounded-lg shadow-md p-4 flex flex-col gap-2 w-[320px]'
        align='start'
        sideOffset={8}
      >
        <a
          href='mailto:support@shopflo.com'
          className='flex items-center justify-between gap-2 hover:bg-gray-light py-2 px-3 rounded-xl no-underline'
          onClick={() => {
            sendGTMTrigger('support_page_button_clicked', 'click', {
              actionType: 'contact_us_email'
            })
          }}
        >
          <div className='flex items-center gap-3'>
            <Mail />
            <span className='text-sm font-medium text-carbon'>{t('support_email')}</span>
          </div>
          <ExternalLink size={24} />
        </a>

        <div
          className='flex items-center justify-between gap-2 hover:bg-gray-light py-2 px-3 rounded-xl'
          onClick={() => {
            sendGTMTrigger('support_page_button_clicked', 'click', {
              actionType: 'contact_us_whatsapp'
            })
          }}
        >
          <div className='flex items-center gap-3'>
            <WhatsApp />
            <a className='text-sm font-medium text-carbon' href='https://wa.me/918105543573' target='_blank'>
              {t('whatsApp_us')}
            </a>
          </div>
          <ExternalLink size={24} />
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default ContactUsPopover
